var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tables-home" }, [
    _c(
      "div",
      { staticClass: "route-page-content" },
      [
        _c("SidebarChild", {
          attrs: {
            items: _vm.menuItems,
            focusActive: true,
            selectedItem: _vm.selectedItem,
            "default-open": "",
          },
          on: { selected: _vm.handleSidebarSelection },
        }),
        _vm._v(" "),
        _vm.selectedItem === "all-tables" ? _c("TableList") : _vm._e(),
        _vm._v(" "),
        _vm.selectedItem === "modules"
          ? _c("ModuleList", { attrs: { mode: "module" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedItem === "relations"
          ? _c("ModuleList", { attrs: { mode: "relation" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedItem === "sandbox" ? _c("TableSandbox") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }